import React from "react";

function Footer() {
  return (
    <>
      <div className="footerBottom">
        <p>© Potluck Planner 2020 </p>
      </div>
    </>
  );
}

export default Footer;
